<!--  -->
<template>
  <div class="card">
    <div class="express-name">
      <h1>
        <span class="name">{{ cardInfo.expressName }}</span
        ><b>{{ cardInfo.expressNo }}</b>
      </h1>
      <button @click="openDeliver()">查看物流</button>
    </div>
    <div class="course">
      <p v-for="(item, index) in cardInfo.wdtExpressGoodsRespVOList" :key="index">
        <span v-if="index < showNum"> {{ item.goodsName }}</span>
        <b v-if="index < showNum">x{{ item.num }}</b>
      </p>
    </div>
    <div class="more" @click="openMore" v-if="cardInfo.wdtExpressGoodsRespVOList.length > 3">
      <span>{{ show ? '收起' : '展开' }}</span>
      <van-icon v-show="!show" name="arrow-down" />
      <van-icon v-show="show" name="arrow-up" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    cardInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      showNum: 3, // 默认展示3条
    };
  },
  computed: {},
  watch: {},
  methods: {
    openMore() {
      this.show = !this.show;
      this.showNum = !this.show ? 3 : this.cardInfo.wdtExpressGoodsRespVOList.length;
    },
    openDeliver() {
      this.$emit('lookLogistics', this.cardInfo.expressNo);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.card {
  position: relative;
  width: 670px;
  margin: 0 auto 20px;
  padding: 0 0 24px 0;
  background: #fff;
  border-radius: 16px;
  .express-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 32px;
    border-bottom: 1px solid #f5f5f5;
    h1 {
      display: flex;
      align-items: center;
      .name {
        padding: 0 10px;
        color: #333;
        font-weight: 800;
        font-size: 28px;
      }
      b {
        display: inline-block;
        width: 300px;
        overflow: hidden;
        color: #787878;
        font-size: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    button {
      height: 40px;
      padding: 0 12px;
      color: #ff7f41;
      font-size: 22px;
      line-height: 40px;
      text-align: center;
      background: #fff;
      border: none;
    }
  }
  .course {
    padding: 28px 32px 0 32px;
    p {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0 0 0;
      line-height: 40px;
      span {
        display: inline-block;
        width: 500px;
        color: #787878;
        font-size: 28px;
        line-height: 40px;
      }
      b {
        color: #999;
        font-weight: 400;
        font-size: 26px;
      }
    }
  }
  .more {
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    span {
      padding: 0 5px 0 0;
      color: #a5a5a5;
      font-size: 24px;
    }
    ::v-deep .van-icon {
      position: relative;
      top: -2px;
      color: #a5a5a5;
      font-size: 15px;
    }
  }
}
</style>
